import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import styled from 'styled-components';

export type LanguageSelectProps = {
  localesOptions: Record<any, any>;
};

const HelpSelect = ({ localesOptions }: LanguageSelectProps) => {
  const HELP_OPTION = 'Help';
  const router = useRouter();
  const [selectedValue, setSelectedValue] = useState(HELP_OPTION);
  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedValue(HELP_OPTION);
    router.push(e.target.value);
  };

  return (
    <Wrapper>
      <StyledSelect onChange={handleSelect} value={selectedValue}>
        <StyledOption value="" hidden>
          {HELP_OPTION}
        </StyledOption>
        {Object.entries(localesOptions).map(([value, label], idx) =>
          value && label ? (
            <StyledOption key={idx} value={label}>
              {value}
            </StyledOption>
          ) : null,
        )}
      </StyledSelect>
      <StyledChevron />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
`;

const StyledSelect = styled.select`
  padding: 9px 35px 9px 17px;
  border: 1px solid ${({ theme }) => theme.colors.grayDark2};
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  width: 100%;
  appearance: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grayDark3};
`;

const StyledOption = styled.option`
  font-size: 16px;
  padding: 0 !important;
  color: ${({ theme }) => theme.colors.grayDark3};
`;

const StyledChevron = styled(ChevronDownIcon)`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: ${({ theme }) => theme.colors.grayDark3};
`;

export default HelpSelect;
